"use client"

import usePostPageMetrics from "@/lib/hooks/usePostPageMetrics"

/**
 * Just calls the hook that tracks the post page view.
 */
export default function PostMetricsWrapperClient({
  postId,
  blogId,
}: {
  postId: string
  blogId: string
}) {
  usePostPageMetrics({ postId, blogId })

  return null
}
